<template>
  <div class="page">
    <div class="header">
      <HeaderPage :isShowHomePageButton="false"></HeaderPage>
    </div>
    <div
      class="body"
      v-loading="loadingStatus"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="leftEchats">
        <el-card class="recentMonthsCostCard">
          <div slot="header" class="cardHeader">
            <span>近几月消费概览</span>
          </div>
          <!-- 最近6月消费一览 -->
          <div class="recentMonthsCost">
            <EChartsView
              :options="recentMonthsOption"
              style="width: 28vw; height: 26vh"
            />
          </div>
        </el-card>
        <el-card
          class="recentMonthsCostCard recentMonthsCostCardLeftTwo"
          v-loading="pointMonthLoading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <HomeCostCalendar
            v-model="currentDay"
            :cost-map="recent30DaysCost"
            :income-map="recent30DaysIncomeRecords"
            @day-dblclick="searchCostRecordsByCostDay"
          />
        </el-card>
      </div>
      <div class="handler" style="width: 40vh; height: 75vh">
        <el-card class="currentPeriodCost recentMonthsCostCard">
          <div slot="header">
            <div class="changePeriod">
              <div class="choosePeriodType">
                <span class="cardHeader" style="font-size: 15px">当前周期</span>
                <el-switch
                  v-model="chooseYear"
                  active-text="年"
                  inactive-text="月">
                </el-switch>
              </div>
              <div v-if="chooseYear" class="homePeriodDateField">
                <el-date-picker
                  v-model="period"
                  type="year"
                  size="mini"
                  format="yyyy"
                  value-format="yyyy"
                  placeholder="选择周期"
                  popper-class="homePeriodPickerPopper"
                  @change="getHomePageParams()"
                >
                </el-date-picker>
              </div>
              <div v-else class="homePeriodDateField homePeriodDateFieldMonth">
                <el-date-picker
                  v-model="period"
                  type="month"
                  size="mini"
                  format="yyyy年MM月"
                  value-format="yyyy-MM"
                  placeholder="选择周期"
                  popper-class="homePeriodPickerPopper"
                  @change="getHomePageParams()"
                >
                </el-date-picker>
              </div>
            </div>
          </div>
          <el-row :gutter="20" class="title-row-show">
            <!-- 同比增长 / 降低 -->
            <el-col :span="12">
              <div>
                <el-statistic group-separator="," :precision="2">
                  <template slot="title">
                    <span class="currentPeriodTitle" v-if="isGrowth">同比增长</span>
                    <span class="currentPeriodTitle" v-else="isGrowth">同比降低</span>
                  </template>
                  <template slot="formatter">
                    <span
                      v-if="isGrowth"
                      class="currentPeriodValue"
                      style="color: chocolate"
                    >{{ relativeGrowth }}</span
                    >
                    <span
                      v-else="isGrowth"
                      class="currentPeriodValue"
                      style="color: #488648"
                    >{{ relativeGrowth }}</span
                    >
                  </template>
                  <template slot="suffix">
                    <IconSvg
                      :icon-style="'icon'"
                      icon-class="icon-fuqian"
                    ></IconSvg>
                  </template>
                  <template v-if="isGrowth" slot="prefix">
                    <IconSvg
                      :icon-style="'icon'"
                      icon-class="icon-zengchang"
                    ></IconSvg>
                  </template>
                  <template v-else slot="prefix">
                    <IconSvg
                      :icon-style="'icon'"
                      icon-class="icon-xiajiang"
                    ></IconSvg>
                  </template>
                </el-statistic>
              </div>
            </el-col>
            <!-- 预支金额 -->
            <el-col :span="12">
              <div class="todayTotalCostTitle" @click="searchAdvanceRecords()">
                <el-statistic group-separator=",">
                  <template slot="title">
                    <span class="currentPeriodTitle">预支金额</span>
                  </template>
                  <template slot="formatter">
                    <span class="currentPeriodValue">{{
                        currentPeriodAdvanceAmount
                      }}</span>
                  </template>
                  <template slot="suffix">
                    <IconSvg
                      :icon-style="'icon'"
                      icon-class="icon-fuqian"
                    ></IconSvg>
                  </template>
                </el-statistic>
              </div>
            </el-col>
            <!-- 今日总计消费：占一整行，放在下方 -->
            <el-col :span="24" style="margin-top: 16px">
              <div class="todayTotalCostTitle" @click="searchTodayCost()">
                <el-statistic group-separator=",">
                  <template slot="title">
                    <span class="currentPeriodTitle">今日总计消费</span>
                  </template>
                  <template slot="formatter">
                    <span class="currentPeriodValue">{{ todayTotalCost }}</span>
                  </template>
                  <template slot="suffix">
                    <IconSvg
                      :icon-style="'icon'"
                      icon-class="icon-fuqian"
                    ></IconSvg>
                  </template>
                </el-statistic>
              </div>
            </el-col>
          </el-row>
          <!-- 当前账期消费情况：列表展示 -->
          <div class="currentAccountPeriod">
            <div class="currentAccountHeader">
              <div class="currentAccountTitle">本周期总消费</div>
              <div class="currentAccountTotal">
                {{ currentAccountPeriodTotal }}
                <span class="currentAccountUnit">¥</span>
              </div>
            </div>
            <div class="currentAccountList">
              <div
                class="currentAccountItem"
                v-for="item in currentAccountPeriodTotalRecord"
                :key="item.costTypeId"
                @click="searchCurrentPeriodCostByType(item)"
              >
                <div class="currentAccountItemHeader">
                  <div class="currentAccountItemNameWrap">
                    <IconSvg
                      :icon-style="'icon'"
                      :icon-class="item.costTypeIcon"
                      class="currentAccountItemIcon"
                    ></IconSvg>
                    <span class="currentAccountItemName">{{ item.costTypeName }}</span>
                  </div>
                  <span class="currentAccountItemAmount">{{ item.costTotalAmount }}元</span>
                </div>
                <div class="currentAccountProgress">
                  <div
                    class="currentAccountProgressInner"
                    :style="{ width: getCostPercent(item) }"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </div>
      <el-card class="currentMonthAnalysis recentMonthsCostCard">
        <div slot="header" class="analysisHeader">
          <span class="analysisHeaderTitle">近几月消费统计分析</span>
        </div>
        <div class="analysisChartWrap">
          <EChartsView
            :options="currentPeriodMonthOption"
            :onEvents="currentPeriodMonthEvents"
            style="width: 100%; height: 78vh"
          />
        </div>
      </el-card>
      <HomePeriodRecordsDialog
        :visible.sync="currentPeriodCostRecordsDiaLog"
        :loading="dialogLoading"
        :activeName.sync="activeName"
        :costList="currentPeriodCostList"
        :incomeList="pointDayIncomeList"
        @tab-click="handleChangeActiveName"
      />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HeaderPage from "@/components/header/Header.vue";
import EChartsView from "@/components/charts/EChartsView";
import HomePeriodRecordsDialog from "./components/HomePeriodRecordsDialog.vue";
import HomeCostCalendar from "./components/HomeCostCalendar.vue";
import {
  queryCostByDate,
  queryCostByMonth,
  queryHomePage,
  queryPeriodByCostTypeAndMonthStr,
} from "../../network/accountRequest";
import IconSvg from "../../components/common/IconSvg";

export default {
  name: "HomeView",
  components: {
    HeaderPage,
    IconSvg,
    EChartsView,
    HomePeriodRecordsDialog,
    HomeCostCalendar,
  },
  data() {
    return {
      // 是否筛选年
      chooseYear: false,
      activeName: "first",
      // 当前账期消费金额
      currentAccountPeriodTotal: 0,
      currentAccountPeriodTotalRecord: [],
      // 当前账期消费笔数
      currentAccountPeriodCostTotal: 0,
      // 当前账期平均每日消费
      currentPeriodAverageCostAmount: 0,
      // 当前周期预支金额
      currentPeriodAdvanceAmount: 0,
      // 近近月消费情况分析
      currentMonthsPeriodCost: [],
      // 当日消费记录
      accountData: [],
      // 当前周期预支消费明细
      currentPeriodAdvanceCostRecords: [],
      // 今日消费总计：
      todayTotalCost: 0,
      // 今日消费记录信息
      todayCostRecords: [],
      // 近30天消费
      recent30DaysCost: {},
      // 近30日收入情况
      recent30DaysIncomeRecords: {},
      // 全局加载状态
      loadingStatus: false,
      // 指定月份的消费信息加载
      pointMonthLoading: false,
      // 当前周期明细筛选
      currentPeriodCostRecordsDiaLog: false,
      // 当前周期筛选弹窗加载
      dialogLoading: false,
      // 相对上一周期是否增长
      isGrowth: true,
      // 当前周期筛选结果列表
      currentPeriodCostList: [],
      // 当前周期筛选收入结果列表
      pointDayIncomeList: [],
      relativeGrowth: 0,
      // 当前时间
      currentDay: new Date(),
      period: "",
      recentMonthsOption: null,
      totalCostOption: null,
      currentPeriodMonthOption: null,
      totalCostDataIndices: [],
    };
  },
  computed: {
    totalCostEvents() {
      return {
        highlight: this.onTotalCostHighlight,
        downplay: this.onTotalCostDownplay,
        dblclick: this.onTotalCostDblclick,
        mouseover: this.onTotalCostMouseover,
        mouseout: this.onTotalCostMouseout,
      };
    },
    currentPeriodMonthEvents() {
      return {
        updateAxisPointer: this.onCurrentPeriodMonthUpdateAxisPointer,
      };
    },
  },
  mounted() {
  },
  created() {
    this.getHomePageParams();
  },
  methods: {
    // getHomePage
    getHomePageParams() {
      this.loadingStatus = true;
      queryHomePage(this.period)
        .then((res) => {
          // 设置当前账期消费情况
          this.currentAccountPeriodTotal = res.data.currentPeriodCost.totalCost;
          this.currentAccountPeriodTotalRecord =
            res.data.currentPeriodCost.costTypeTotalDTOS;
          console.log("=====1111");
          const data = (this.currentAccountPeriodTotalRecord || []).map((item) => ({
            name: `${item.costTypeName}`,
            value: `${item.costTotalAmount}`,
            id: `${item.costTypeId}`,
          }));
          this.setCurrentAccountPeriodOption(data);
          // 设置近几月消费情况
          this.setRecentMonthsOption(res.data.recentMonthsDTOS);
          // 近几月消费情况分析
          this.currentMonthsPeriodCost = res.data.currentMonthsPeriodCost;
          console.log("=====22222");
          // 设置今日消费情况
          this.accountData = res.data.todayRecordTotalDTO.todayCostRecords;
          this.todayTotalCost = res.data.todayRecordTotalDTO.totalCost;
          this.todayCostRecords = res.data.todayRecordTotalDTO.todayCostRecords;
          this.currentPeriodAdvanceCostRecords =
            res.data.currentPeriodAdvanceRecords;
          // 设置近30日消费情况
          this.recent30DaysCost = this.formatCostData(
            res.data.recent30DaysCost
          );
          this.recent30DaysIncomeRecords = this.formatIncomeData(
            res.data.recent30DaysCost
          );
          // 设置相对上周期消费情况
          this.isGrowth = res.data.relativeGrowthDTO.isGrowth;
          this.relativeGrowth = res.data.relativeGrowthDTO.relativeAmount;
          // 当前账期总计消费笔数
          this.currentAccountPeriodCostTotal =
            res.data.currentAccountPeriodCostTotal;
          // 当前账期预支金额
          this.currentPeriodAdvanceAmount = res.data.currentPeriodAdvanceAmount;
          // 当前账期平均每日消费
          console.log("====33333");
          this.currentPeriodAverageCostAmount =
            res.data.currentPeriodAverageCostAmount;
          this.setCurrentMonthsPeriodCostAnalysisOption();
        })
        .finally(() => {
          this.loadingStatus = false;
        });
    },
    // 今日消费
    searchTodayCost() {
      this.$set(this, "currentPeriodCostList", this.todayCostRecords);
      this.currentPeriodCostRecordsDiaLog = true;
    },
    // 当前周期预支明细
    searchAdvanceRecords() {
      this.$set(
        this,
        "currentPeriodCostList",
        this.currentPeriodAdvanceCostRecords
      );
      this.currentPeriodCostRecordsDiaLog = true;
    },
    // 设置近几月的消费信息分析
    setCurrentMonthsPeriodCostAnalysisOption() {
      var source = [];
      var costMonths = ["消费类型"];
      costMonths = costMonths.concat(this.currentMonthsPeriodCost.costYearList);
      source.push(costMonths);
      const defaultDimension = Math.max(1, costMonths.length - 1);
      const defaultTotalAmount = (this.currentMonthsPeriodCost.costTypeList || []).reduce(
        (sum, item) => {
          const arr = (item && item.costTotal) || [];
          return sum + Number(arr[defaultDimension - 1] || 0);
        },
        0
      );
      let series = [];
      for (
        let dataIndex = 0;
        dataIndex < this.currentMonthsPeriodCost.costTypeList.length;
        dataIndex++
      ) {
        const element = this.currentMonthsPeriodCost.costTypeList[dataIndex];
        var name = element.costTypeName;
        var costRecords = [name];
        costRecords = costRecords.concat(element.costTotal);
        source.push(costRecords);
        // 行
        let se = {
          type: "line",
          smooth: true,
          seriesLayoutBy: "row",
          symbol: "circle",
          symbolSize: 7,
          lineStyle: {
            width: 3,
            shadowColor: "rgba(56, 189, 248, 0.55)",
            shadowBlur: 14,
          },
          itemStyle: {
            borderWidth: 2,
            borderColor: "rgba(15, 23, 42, 0.95)",
            shadowColor: "rgba(56, 189, 248, 0.5)",
            shadowBlur: 10,
          },
          areaStyle: {
            opacity: 0.16,
          },
          emphasis: {focus: "series"},
        };
        series.push(se);
      }
      let finallySe = {
        type: "pie",
        id: "pie",
        radius: ["23%", "35%"],
        center: ["32%", "25%"],
        z: 3,
        itemStyle: {
          color: (params) => {
            const list = [
              ["rgba(125, 211, 252, 0.9)", "rgba(37, 99, 235, 0.9)"],
              ["rgba(196, 181, 253, 0.9)", "rgba(99, 102, 241, 0.9)"],
              ["rgba(153, 246, 228, 0.9)", "rgba(15, 118, 110, 0.9)"],
              ["rgba(147, 197, 253, 0.9)", "rgba(59, 130, 246, 0.9)"],
              ["rgba(221, 214, 254, 0.9)", "rgba(109, 40, 217, 0.9)"],
              ["rgba(110, 231, 183, 0.9)", "rgba(16, 185, 129, 0.9)"],
            ];
            const current = list[params.dataIndex % list.length];
            return new this.$echarts.graphic.LinearGradient(0, 0, 1, 1, [
              { offset: 0, color: current[0] },
              { offset: 1, color: current[1] },
            ]);
          },
          borderColor: "rgba(15, 23, 42, 0.8)",
          borderWidth: 1.2,
          shadowColor: "transparent",
          shadowBlur: 0,
          shadowOffsetY: 0,
        },
        emphasis: {
          focus: "self",
          scale: true,
          scaleSize: 4,
          itemStyle: {
            shadowColor: "transparent",
            shadowBlur: 0,
            shadowOffsetY: 0,
          },
        },
        label: {
          show: true,
          position: "center",
          formatter: `{name|总额度}\n{value|${this.formatLegendValue(defaultTotalAmount)}}`,
          rich: {
            name: {
              color: "rgba(191, 219, 254, 0.9)",
              fontSize: 14,
              fontWeight: 600,
              lineHeight: 20,
              letterSpacing: 1.5,
              fontFamily: "Orbitron, Rajdhani, 'Microsoft YaHei', sans-serif",
              textBorderColor: "rgba(15, 23, 42, 0.72)",
              textBorderWidth: 1,
            },
            value: {
              color: "#22d3ee",
              fontSize: 21,
              fontWeight: 700,
              lineHeight: 30,
              letterSpacing: 1,
              fontFamily: "Orbitron, Rajdhani, 'DIN Alternate', 'Microsoft YaHei', sans-serif",
              textBorderColor: "rgba(6, 182, 212, 0.45)",
              textBorderWidth: 0.8,
              textShadowColor: "rgba(34, 211, 238, 0.46)",
              textShadowBlur: 14,
            },
          },
        },
        encode: {
          itemName: "消费类型",
          value: defaultDimension,
          tooltip: defaultDimension,
        },
      };
      series.push(finallySe);

      this.currentPeriodMonthOption = {
        color: [
          "#38bdf8",
          "#818cf8",
          "#22d3ee",
          "#60a5fa",
          "#a78bfa",
          "#34d399",
        ],
        legend: {
          orient: "vertical",
          right: "5%",
          top: "14%",
          icon: "roundRect",
          itemWidth: 12,
          itemHeight: 8,
          itemGap: 10,
          width: "32%",
          textStyle: {
            color: "rgba(191, 219, 254, 0.9)",
            fontSize: 12,
            rich: {
              name: {
                width: 92,
                color: "rgba(191, 219, 254, 0.92)",
                fontSize: 12,
                lineHeight: 18,
              },
              value: {
                width: 70,
                align: "right",
                color: "#bfdbfe",
                fontSize: 12,
                fontWeight: 600,
                lineHeight: 18,
              },
            },
          },
          formatter: this.buildLegendFormatter(defaultDimension),
        },
        tooltip: {
          trigger: "axis",
          showContent: false,
          backgroundColor: "rgba(2, 6, 23, 0.9)",
          borderColor: "rgba(56, 189, 248, 0.25)",
          borderWidth: 1,
          textStyle: {
            color: "#dbeafe",
          },
        },
        dataset: {
          source: source,
        },
        xAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              color: "rgba(148, 163, 184, 0.8)",
            },
          },
          axisLabel: {
            color: "rgba(148, 163, 184, 0.9)",
          },
        },
        yAxis: {
          gridIndex: 0,
          axisLine: {
            lineStyle: {
              color: "rgba(148, 163, 184, 0.8)",
            },
          },
          splitLine: {
            lineStyle: {
              color: "rgba(30, 64, 175, 0.55)",
              type: "dashed",
            },
          },
          axisLabel: {
            color: "rgba(148, 163, 184, 0.9)",
          },
        },
        grid: { top: "50%", left: "6%", right: "4%", bottom: "10%" },
        series: series,
      };
    },
    onCurrentPeriodMonthUpdateAxisPointer(event, chart) {
      const xAxisInfo = event && event.axesInfo && event.axesInfo[0];
      if (!xAxisInfo || !chart) return;
      const dimension = xAxisInfo.value + 1;
      chart.setOption({
        legend: {
          formatter: this.buildLegendFormatter(dimension),
        },
        series: {
          id: "pie",
          label: {
            formatter: `{name|{b}}\n{value|{@[${dimension}]}}`,
            rich: {
              name: {
                color: "rgba(191, 219, 254, 0.9)",
                fontSize: 14,
                fontWeight: 600,
                lineHeight: 20,
                letterSpacing: 1.5,
                fontFamily: "Orbitron, Rajdhani, 'Microsoft YaHei', sans-serif",
                textBorderColor: "rgba(15, 23, 42, 0.72)",
                textBorderWidth: 1,
              },
              value: {
                color: "#22d3ee",
                fontSize: 21,
                fontWeight: 700,
                lineHeight: 30,
                letterSpacing: 1,
                fontFamily: "Orbitron, Rajdhani, 'DIN Alternate', 'Microsoft YaHei', sans-serif",
                textBorderColor: "rgba(6, 182, 212, 0.45)",
                textBorderWidth: 0.8,
                textShadowColor: "rgba(34, 211, 238, 0.46)",
                textShadowBlur: 14,
              },
            },
          },
          encode: {
            value: dimension,
            tooltip: dimension,
          },
        },
      });
    },
    getLegendValueByName(name, dimension) {
      const source = (this.currentPeriodMonthOption &&
        this.currentPeriodMonthOption.dataset &&
        this.currentPeriodMonthOption.dataset.source) || [];
      const row = source.find((item, idx) => idx > 0 && item[0] === name);
      if (!row) return 0;
      return Number(row[dimension] || 0);
    },
    formatLegendName(name, maxLength = 6) {
      const text = String(name || "");
      if (text.length <= maxLength) return text;
      return `${text.slice(0, maxLength)}...`;
    },
    formatLegendValue(value) {
      const num = Number(value || 0);
      return Number.isFinite(num) ? num.toLocaleString() : "0";
    },
    buildLegendFormatter(dimension) {
      return (name) => {
        const shortName = this.formatLegendName(name, 6);
        const value = this.getLegendValueByName(name, dimension);
        return `{name|${shortName}}{value|${this.formatLegendValue(value)}}`;
      };
    },
    // 点击当前账期列表项，按消费类型查看明细
    searchCurrentPeriodCostByType(item) {
      if (!item || !item.costTypeId) return;
      const costTypeId = item.costTypeId;
      this.dialogLoading = true;
      this.currentPeriodCostRecordsDiaLog = true;
      const queryData = {
        costTypeId,
        monthStr: this.period,
      };
      queryPeriodByCostTypeAndMonthStr(queryData)
        .then((res) => {
          this.currentPeriodCostList = res.data;
        })
        .finally(() => {
          this.dialogLoading = false;
        });
    },
    // 计算当前账期各类型消费进度条百分比
    getCostPercent(item) {
      const total = Number(this.currentAccountPeriodTotal || 0);
      const value = Number(item && item.costTotalAmount ? item.costTotalAmount : 0);
      if (!total || value <= 0) {
        return "0%";
      }
      const percent = Math.min(100, Math.round((value / total) * 100));
      return `${percent}%`;
    },
    // 设置echartsData信息
    setCurrentAccountPeriodOption(data) {
      this.totalCostDataIndices = Object.keys(data);
      this.totalCostOption = {
        title: {
          show: false,
        },
        tooltip: {
          trigger: "item",
        },

        series: [
          {
            name: "",
            type: "pie",
            center: ["50%", "50%"],
            radius: ["60%", "95%"],
            hoverOffset: 20,
            label: {
              normal: {
                show: true,
                position: "center",
                formatter: () => {
                  return `{value|￥${this.currentAccountPeriodTotal}}`;
                },
                rich: {
                  value: {
                    fontSize: 26,
                    lineHeight: 38,
                    color: "#facc15",
                    fontWeight: "700",
                    align: "center",
                    textShadowColor: "rgba(56, 189, 248, 0.75)",
                    textShadowBlur: 16,
                    textShadowOffsetX: 0,
                    textShadowOffsetY: 0,
                  },
                },
              },
              emphasis: {
                show: true,
                formatter: function (params) {
                  return `{a|${params.name}}\n` + `{b|${params.value}}`;
                },
                //中间文字样式
                rich: {
                  a: {
                    color: function (params) {
                    },
                    fontSize: 20,
                    lineHeight: 48,
                  },
                  b: {
                    color: function (params) {
                    },
                    align: "center",
                    fontSize: 20,
                    lineHeight: 48,
                  },
                },
              },
            },

            data: data,
          },
        ],
      };
    },
    onTotalCostHighlight(_params, chart) {
      if (!chart) return;
      chart.setOption({ title: { show: false } });
    },
    onTotalCostDownplay(_params, chart) {
      if (!chart) return;
      chart.setOption({ title: { show: true } });
    },
    onTotalCostDblclick(params) {
      const costTypeId = params && params.data && params.data.id;
      if (!costTypeId) return;
      this.dialogLoading = true;
      this.currentPeriodCostRecordsDiaLog = true;
      const queryData = {
        costTypeId,
        monthStr: this.period,
      };
      queryPeriodByCostTypeAndMonthStr(queryData)
        .then((res) => {
          this.currentPeriodCostList = res.data;
        })
        .finally(() => {
          this.dialogLoading = false;
        });
    },
    onTotalCostMouseover(params, chart) {
      if (!chart) return;
      chart.dispatchAction({
        type: "downplay",
        seriesIndex: 0,
        dataIndex: this.totalCostDataIndices,
      });
      chart.dispatchAction({
        type: "highlight",
        seriesIndex: 0,
        dataIndex: params.dataIndex,
      });
      chart.setOption({ title: { show: false } });
    },
    onTotalCostMouseout(_params, chart) {
      if (!chart) return;
      chart.dispatchAction({
        type: "downplay",
        seriesIndex: 0,
        dataIndex: this.totalCostDataIndices,
      });
      chart.setOption({ title: { show: true } });
    },
    // 设置近6月echatsData信息
    setRecentMonthsOption(data) {
      const list = Array.isArray(data) ? data : [];
      const keys = list.map((item) => item.costMonthStr);
      const value = list.map((item) => item.costAmount);
      this.recentMonthsOption = {
        title: {
          show: false,
          text: "",
          textStyle: {
            fontSize: 14,
            lineHeight: 28,
            color: "#7dd3fc",
          },
        },
        grid: {
          left: "4.5%",
          right: "2.5%",
          containLabel: true,
        },
        xAxis: {
          axisLine: {
            lineStyle: {
              color: "rgba(148, 163, 184, 0.7)",
            },
          },
          axisLabel: {
            color: "rgba(148, 163, 184, 0.9)",
          },
          data: keys,
        },
        yAxis: {
          axisLine: {
            lineStyle: {
              color: "rgba(148, 163, 184, 0.7)",
            },
          },
          splitLine: {
            lineStyle: {
              color: "rgba(30, 64, 175, 0.45)",
              type: "dashed",
            },
          },
          axisLabel: {
            color: "rgba(148, 163, 184, 0.9)",
          },
        },
        series: [
          {
            type: "bar",
            data: value,
            itemStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "rgba(56, 189, 248, 0.95)" },
                { offset: 1, color: "rgba(37, 99, 235, 0.85)" },
              ]),
              emphasis: {
                label: {
                  show: true,
                  // 展示信息
                  formatter: function (params) {
                    return `${params.name}消费\n${params.data} 元`;
                  },
                  //一下为label的一些配置项，设置外边框，背景颜色，字体颜色等
                  backgroundColor: "rgba(15, 23, 42, 0.96)",
                  borderColor: "rgba(56, 189, 248, 0.8)",
                  borderWidth: 0.5,
                  borderRadius: 2,
                  padding: 6,
                  position: "top",
                  textStyle: {
                    color: "#7dd3fc",
                    fontSize: 16,
                    marginLeft: 0,
                    lineHeight: 20,
                  },
                },
              },
            },
          },
        ],
      };
    },
    handleChangeActiveName(tab, event) {
    },
    // 查询指定日期的消费信息
    searchCostRecordsByCostDay(costDay) {
      this.dialogLoading = true;
      this.currentPeriodCostRecordsDiaLog = true;
      queryCostByDate(costDay)
        .then((res) => {
          this.currentPeriodCostList = res.data.costList;
          this.pointDayIncomeList = res.data.incomeList;
        })
        .finally(() => {
          this.dialogLoading = false;
        });
    },
    // 设置近30日的消费
    formatCostData(data) {
      const map = {};
      data.forEach((item) => {
        if (item.costAmount) {
          map[item.costDay] = `-${item.costAmount}`; // 存入消费数据
        }
      });
      return map;
    },
    // 设置指定日期收入信息
    formatIncomeData(data) {
      const map = {};
      data.forEach((item) => {
        if (item.incomeAmount) {
          map[item.costDay] = `+${item.incomeAmount}`; // 存入收入数据
        }
      });
      return map;
    },
    // 通过日期获取月份
    getMonthKey(date) {
      // 生成 YYYY-MM 格式的 key
      const d = new Date(date);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
    },
  },
  watch: {
    currentDay: function (newDate, oldDate) {
      // 检测月份变化（格式 yyyy-mm）
      if (!oldDate) {
        return;
      }
      const newMonth = this.getMonthKey(newDate);
      const oldMonth = this.getMonthKey(oldDate);
      if (newMonth !== oldMonth) {
        this.pointMonthLoading = true;
        queryCostByMonth(newMonth)
          .then((res) => {
            this.recent30DaysCost = this.formatCostData(res.data);
            this.recent30DaysIncomeRecords = this.formatIncomeData(res.data);
          })
          .finally(() => {
            this.pointMonthLoading = false;
          });
      }
    },
  },
};
</script>
<style lang="css" scoped>
.page {
  position: relative;
  height: 98vh;
  padding: 10px 0 0;
  background:
    radial-gradient(circle at 0% 0%, rgba(56, 189, 248, 0.08), transparent 55%),
    radial-gradient(circle at 100% 100%, rgba(129, 140, 248, 0.12), transparent 55%),
    radial-gradient(circle at 100% 0%, rgba(45, 212, 191, 0.08), transparent 55%),
    #020617;
  color: #e5e7eb;
  overflow: hidden;
}

.leftEchats {
  margin-top: 20px;
  padding-left: 0;
  padding-right: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  height: 80vh;
  min-height: 0;
  flex-shrink: 0;
}

.leftEchats > .recentMonthsCostCard:first-child {
  flex-shrink: 0;
}

.header {
  position: relative;
  z-index: 2;
}

/* 去掉 el-card header 下边框 */
/deep/ .el-card__header {
  border-bottom: none !important;
  padding-bottom: 10px;
}

/deep/ .el-card__body {
  padding-top: 0;
}

.recentMonthsCostCard {
  background: radial-gradient(circle at 0% 0%, rgba(56, 189, 248, 0.06), transparent 55%),
    radial-gradient(circle at 80% 100%, rgba(99, 102, 241, 0.08), transparent 55%),
    rgba(15, 23, 42, 0.92);
  margin-left: 0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  border-radius: 16px;
  border: 1px solid rgba(15, 118, 255, 0.35);
  box-shadow:
    0 18px 45px rgba(15, 23, 42, 0.9),
    0 0 24px rgba(56, 189, 248, 0.18),
    0 0 46px rgba(129, 140, 248, 0.22);
  backdrop-filter: blur(16px);
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
}

.recentMonthsCostCard:hover {
  transform: translateY(-4px);
  border-color: rgba(56, 189, 248, 0.6);
  box-shadow:
    0 24px 60px rgba(15, 23, 42, 0.95),
    0 0 32px rgba(56, 189, 248, 0.32),
    0 0 60px rgba(129, 140, 248, 0.36);
}

.recentMonthsCostCardLeftTwo {
  margin-top: 20px;
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.recentMonthsCostCardLeftTwo /deep/ .el-card__body {
  flex: 1 1 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  overflow: hidden;
  padding: 10px 12px;
  box-sizing: border-box;
  width: 100%;
}

/* 首页自定义消费日历：在卡片内水平铺满、垂直占满剩余高度 */
.recentMonthsCostCardLeftTwo /deep/ .home-cost-calendar {
  flex: 1 1 0;
  min-height: 0;
  width: 100%;
  max-width: 100%;
  align-self: stretch;
  box-sizing: border-box;
}

.currentMonthAnalysis {
  flex: 1 1 0;
  min-width: 0;
  background:
    radial-gradient(circle at 10% 0%, rgba(56, 189, 248, 0.06), transparent 55%),
    radial-gradient(circle at 95% 100%, rgba(129, 140, 248, 0.1), transparent 55%),
    rgba(15, 23, 42, 0.96);
  margin-top: 20px;
  width: auto;
  margin-left: 0;
  margin-right: 0;
  height: 80vh;
  border-radius: 18px;
  border: 1px solid rgba(56, 189, 248, 0.3);
  box-shadow: none;
  overflow: hidden;
  transform: perspective(1000px) rotateX(1.2deg);
  position: relative;
}

.currentMonthAnalysis::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 18px;
  pointer-events: none;
  border: 1px solid rgba(56, 189, 248, 0.22);
  box-shadow: none;
}

.analysisHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 2px;
}

.analysisHeaderTitle {
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.08em;
  color: #93c5fd;
  text-shadow: none;
}

.analysisChartWrap {
  height: 100%;
  border-radius: 14px;
  background:
    linear-gradient(165deg, rgba(15, 23, 42, 0.88), rgba(15, 23, 42, 0.72)),
    radial-gradient(circle at 10% 0%, rgba(34, 211, 238, 0.06), transparent 60%),
    radial-gradient(circle at 100% 100%, rgba(129, 140, 248, 0.07), transparent 60%);
  border: 1px solid rgba(56, 189, 248, 0.12);
  box-shadow: none;
}

.currentPeriodCost {
  background: radial-gradient(circle at 10% 0%, rgba(56, 189, 248, 0.06), transparent 55%),
    radial-gradient(circle at 90% 100%, rgba(45, 212, 191, 0.06), transparent 55%),
    rgba(15, 23, 42, 0.96);
  margin-top: 20px;
  margin-left: 0;
  margin-right: 0;
  height: 80vh;
  width: 100%;
  box-sizing: border-box;
}

.body {
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  gap: 24px;
  padding: 0 20px 0 20px;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
}

/* 中间栏：与左右列间距由 .body 的 gap 统一控制 */
.handler {
  flex-shrink: 0;
  box-sizing: border-box;
}

.currentAccountPeriod {
  width: 100%;
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  padding: 16px 18px 10px;
  box-sizing: border-box;
  row-gap: 12px;
}

.currentAccountHeader {
  text-align: center;
  padding-bottom: 6px;
}

.currentAccountTitle {
  font-size: 14px;
  letter-spacing: 0.16em;
  color: rgba(148, 163, 184, 0.95);
  margin-bottom: 6px;
}

.currentAccountTotal {
  font-size: 28px;
  font-weight: 700;
  color: #7dd3fc;
  text-shadow:
    0 0 14px rgba(56, 189, 248, 0.8),
    0 0 26px rgba(129, 140, 248, 0.75);
}

.currentAccountUnit {
  font-size: 16px;
  margin-left: 4px;
  color: #facc15;
}

.currentAccountList {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  margin-top: 6px;
  max-height: 38vh;
  overflow-y: auto;
}

.currentAccountItem {
  padding: 10px 14px 10px;
  border-radius: 14px;
  background:
    radial-gradient(circle at 0% 0%, rgba(56, 189, 248, 0.18), transparent 55%),
    radial-gradient(circle at 100% 100%, rgba(129, 140, 248, 0.18), transparent 55%),
    linear-gradient(135deg, rgba(15, 23, 42, 0.98), rgba(17, 24, 39, 0.98));
  border: 1px solid rgba(56, 189, 248, 0.28);
  box-shadow:
    0 10px 22px rgba(15, 23, 42, 0.96),
    0 0 20px rgba(15, 118, 255, 0.25),
    inset 0 1px 0 rgba(255, 255, 255, 0.04);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;
}

.currentAccountItem:hover {
  transform: translateY(-2px);
  box-shadow:
    0 14px 30px rgba(15, 23, 42, 0.98),
    0 0 26px rgba(56, 189, 248, 0.5),
    inset 0 1px 0 rgba(255, 255, 255, 0.06);
  border-color: rgba(56, 189, 248, 0.45);
}

.currentAccountItemHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.currentAccountItemNameWrap {
  display: flex;
  align-items: center;
  column-gap: 8px;
}

.currentAccountItemIcon {
  width: 3vh;
  height: 3vh;
}

.currentAccountItemName {
  font-size: 14px;
  color: rgba(226, 232, 240, 0.96);
}

.currentAccountItemAmount {
  font-size: 14px;
  color: #7dd3fc;
  font-weight: 600;
}

.currentAccountProgress {
  position: relative;
  width: 100%;
  height: 6px;
  border-radius: 999px;
  background: linear-gradient(90deg, rgba(30, 64, 175, 0.65), rgba(15, 23, 42, 0.98));
  overflow: hidden;
}

.currentAccountProgressInner {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, rgba(56, 189, 248, 0.95), rgba(59, 130, 246, 0.95));
  box-shadow:
    0 0 10px rgba(56, 189, 248, 0.9),
    0 0 16px rgba(37, 99, 235, 0.9);
}

/* 卡片标题 */
.cardHeader {
  font-size: 16px;
  color: #7dd3fc;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  text-shadow:
    0 0 10px rgba(56, 189, 248, 0.6),
    0 0 18px rgba(129, 140, 248, 0.6);
}

/* 统计信息 */
.title-row-show {
  margin-top: 2vh;
  margin-bottom: 2vh;
  padding: 12px 14px;
  border-radius: 14px;
  background:
    radial-gradient(circle at 0% 0%, rgba(56, 189, 248, 0.06), transparent 55%),
    radial-gradient(circle at 100% 100%, rgba(129, 140, 248, 0.08), transparent 55%),
    rgba(15, 23, 42, 0.9);
  box-shadow:
    0 14px 30px rgba(15, 23, 42, 0.95),
    0 0 20px rgba(56, 189, 248, 0.18),
    0 0 36px rgba(129, 140, 248, 0.22);
  border: 1px solid rgba(56, 189, 248, 0.35);
  transform-style: preserve-3d;
  transition:
    transform 0.25s ease,
    box-shadow 0.25s ease,
    border-color 0.25s ease,
    background 0.25s ease;
}

.title-row-show:hover {
  transform: translateY(-3px);
  border-color: rgba(56, 189, 248, 0.6);
  box-shadow:
    0 20px 40px rgba(15, 23, 42, 0.98),
    0 0 26px rgba(56, 189, 248, 0.32),
    0 0 46px rgba(129, 140, 248, 0.36);
}

.title-row-show .el-statistic {
  position: relative;
  padding: 6px 10px;
}

.title-row-show .el-statistic::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 12px;
  border: 1px solid rgba(56, 189, 248, 0.18);
  background: radial-gradient(circle at 0% 0%, rgba(56, 189, 248, 0.12), transparent 60%);
  opacity: 0;
  transform: translateZ(-1px);
  transition: opacity 0.25s ease;
}

.title-row-show .el-statistic:hover::before {
  opacity: 1;
}

/* 当前周期筛选弹窗 */
.currentPeriodCostRecordsDiaLog {
  background-color: rgba(15, 23, 42, 0.96);
}

.el-dialog__body {
  background-color: rgba(15, 23, 42, 0.98);
}

.el-dialog__header {
  background-color: rgba(15, 23, 42, 0.98);
}

.el-table__header {
  background-color: rgba(15, 23, 42, 0.96);
}

.currentAccountPeriodTitle {
  display: flex;
  justify-items: center;
  justify-items: center;
  color: #7dd3fc;
  font-size: 20px;
}

/* 当前周期展示title */
.currentPeriodTitle {
  font-size: 0.85vw;
  color: rgba(148, 163, 184, 0.98);
}

/* 当前周期展示value */
.currentPeriodValue {
  font-size: 1.3vw;
  color: rgba(250, 204, 21, 0.9);
  text-shadow:
    0 0 10px rgba(250, 204, 21, 0.5),
    0 0 24px rgba(56, 189, 248, 0.35);
}


/* 今日消费title */
.todayTotalCostTitle {
  cursor: pointer;
}

.totalCostTitle {
  color: #7dd3fc;
  font-size: 20px;
}

.currentDayCostRecord {
  width: 40vh;
  height: 60vh;
}

.el-card__header {
  border-bottom: none;
}

/* 设置侧边条 */
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.custom-table-height .el-table__row {
  height: 6.28vh; /* 设置行高为60px */
  font-size: 16px;
}

::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background-image: linear-gradient(180deg, rgba(56, 189, 248, 0.6), rgba(129, 140, 248, 0.8));
}

::-webkit-scrollbar-track {
  background-color: rgba(15, 23, 42, 0.96);
}

::-webkit-scrollbar-thumb,
::-webkit-scrollbar-track {
  border: 0;
}

/deep/ .el-button--plain {
  color: #22d3ee !important;
  background-color: rgba(30, 64, 175, 0.45);
  margin-left: 2px;
  border-color: rgba(56, 189, 248, 0.55);
  box-shadow:
    0 0 10px rgba(56, 189, 248, 0.4),
    0 0 20px rgba(129, 140, 248, 0.35);
  transition: background-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

/deep/ .el-button--plain:hover {
  background-color: rgba(37, 99, 235, 0.75);
  box-shadow:
    0 0 16px rgba(56, 189, 248, 0.75),
    0 0 30px rgba(129, 140, 248, 0.6);
  transform: translateY(-1px);
}

.changePeriod {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  column-gap: 16px;
  padding: 4px 8px 2px;
}

.choosePeriodType {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 8px;
}

.choosePeriodType .cardHeader {
  white-space: nowrap;
}

/* 首页「当前周期」日期选择：加强辨识度与立体感 */
.changePeriod .homePeriodDateField /deep/ .el-date-editor.el-input {
  width: 130px !important;
}

.changePeriod .homePeriodDateFieldMonth /deep/ .el-date-editor.el-input {
  width: 148px !important;
}

.changePeriod .homePeriodDateField /deep/ .el-date-editor.el-input .el-input__inner {
  background: linear-gradient(
    165deg,
    rgba(15, 23, 42, 0.98) 0%,
    rgba(30, 27, 75, 0.92) 45%,
    rgba(15, 23, 42, 0.98) 100%
  ) !important;
  padding-left: 30px !important;
  padding-right: 10px !important;
  border-radius: 999px;
  border: 1px solid rgba(56, 189, 248, 0.55) !important;
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.1),
    0 4px 14px rgba(0, 0, 0, 0.45),
    0 0 0 1px rgba(2, 6, 23, 0.9),
    0 0 18px rgba(56, 189, 248, 0.35),
    0 0 32px rgba(129, 140, 248, 0.22),
    inset 0 1px 0 rgba(255, 255, 255, 0.08),
    inset 0 -1px 0 rgba(0, 0, 0, 0.2);
  color: #e0f2fe !important;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-shadow:
    0 0 8px rgba(56, 189, 248, 0.45),
    0 0 16px rgba(129, 140, 248, 0.2);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.changePeriod .homePeriodDateField /deep/ .el-date-editor.el-input .el-input__inner:hover {
  border-color: rgba(103, 232, 249, 0.75) !important;
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.12),
    0 6px 18px rgba(0, 0, 0, 0.5),
    0 0 0 1px rgba(2, 6, 23, 0.9),
    0 0 22px rgba(56, 189, 248, 0.5),
    0 0 40px rgba(129, 140, 248, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

.changePeriod .homePeriodDateField /deep/ .el-input.is-focus .el-input__inner,
.changePeriod .homePeriodDateField /deep/ .el-date-editor.el-input .el-input__inner:focus {
  border-color: rgba(103, 232, 249, 0.95) !important;
  box-shadow:
    0 0 0 1px rgba(56, 189, 248, 0.4),
    0 0 24px rgba(56, 189, 248, 0.55),
    0 0 44px rgba(129, 140, 248, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.12);
}

.changePeriod .homePeriodDateField /deep/ .el-input__prefix {
  left: 10px;
}

.changePeriod .homePeriodDateField /deep/ .el-input__prefix .el-input__icon {
  color: #67e8f9 !important;
  filter: drop-shadow(0 0 6px rgba(103, 232, 249, 0.75));
}
</style>

<!-- 周期选择面板挂载在 body，scoped 无法命中，需单独全局样式 -->
<style lang="css">
.homePeriodPickerPopper.el-picker-panel,
.homePeriodPickerPopper.el-date-picker {
  position: relative;
  overflow: hidden;
  background: linear-gradient(160deg, rgba(15, 23, 42, 0.98) 0%, rgba(30, 27, 75, 0.96) 100%) !important;
  border: 1px solid rgba(56, 189, 248, 0.55) !important;
  box-shadow:
    0 18px 40px rgba(0, 0, 0, 0.85),
    0 0 26px rgba(56, 189, 248, 0.35),
    0 0 40px rgba(129, 140, 248, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.08),
    inset 0 -1px 0 rgba(0, 0, 0, 0.25) !important;
  border-radius: 14px !important;
  color: #e5e7eb;
}

.homePeriodPickerPopper.el-picker-panel::before {
  content: "";
  position: absolute;
  top: -50px;
  left: -18%;
  width: 140%;
  height: 70px;
  background: linear-gradient(90deg, transparent 0%, rgba(56, 189, 248, 0.18) 45%, transparent 100%);
  transform: rotate(-6deg);
  pointer-events: none;
  z-index: 0;
}

.homePeriodPickerPopper.el-picker-panel::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  pointer-events: none;
  z-index: 1;
}

.homePeriodPickerPopper .el-picker-panel__body,
.homePeriodPickerPopper .el-date-picker__header {
  background-color: transparent !important;
  position: relative;
  z-index: 2;
}

.homePeriodPickerPopper .el-date-picker__header {
  border-bottom: 1px solid rgba(56, 189, 248, 0.22) !important;
}

.homePeriodPickerPopper .el-date-picker__header-label {
  color: #e0f2fe !important;
  font-weight: 600;
  text-shadow: 0 0 10px rgba(56, 189, 248, 0.5);
}

.homePeriodPickerPopper .el-picker-panel__icon-btn {
  color: rgba(148, 163, 184, 0.92) !important;
  transition: color 0.2s ease, text-shadow 0.2s ease;
}

.homePeriodPickerPopper .el-picker-panel__icon-btn:hover {
  color: #67e8f9 !important;
  text-shadow: 0 0 10px rgba(103, 232, 249, 0.8);
}

.homePeriodPickerPopper .el-date-table th {
  color: rgba(148, 163, 184, 0.9) !important;
}

.homePeriodPickerPopper .el-date-table td span,
.homePeriodPickerPopper .el-year-table td .cell,
.homePeriodPickerPopper .el-month-table td .cell {
  background-color: transparent !important;
  color: rgba(209, 213, 219, 0.92) !important;
  border-radius: 10px;
  transition: background 0.2s ease, box-shadow 0.2s ease, color 0.2s ease, transform 0.2s ease;
}

.homePeriodPickerPopper .el-date-table td.today span {
  color: #7dd3fc !important;
  border-color: rgba(56, 189, 248, 0.7);
}

.homePeriodPickerPopper .el-date-table td.current span,
.homePeriodPickerPopper .el-date-table td.available:hover span,
.homePeriodPickerPopper .el-year-table td.current:not(.disabled) .cell,
.homePeriodPickerPopper .el-year-table td .cell:hover,
.homePeriodPickerPopper .el-month-table td.current:not(.disabled) .cell,
.homePeriodPickerPopper .el-month-table td.current:not(.disabled) a.cell,
.homePeriodPickerPopper .el-month-table td .cell:hover,
.homePeriodPickerPopper .el-month-table td a.cell:hover {
  background: linear-gradient(135deg, rgba(56, 189, 248, 0.95), rgba(129, 140, 248, 0.9)) !important;
  color: #0b1120 !important;
  font-weight: 700;
  box-shadow:
    0 0 12px rgba(56, 189, 248, 0.85),
    0 0 22px rgba(129, 140, 248, 0.65) !important;
  transform: translateY(-1px);
  border: none !important;
}

.homePeriodPickerPopper .el-year-table td.today .cell,
.homePeriodPickerPopper .el-month-table td.today .cell,
.homePeriodPickerPopper .el-month-table td.today a.cell {
  color: #d9f6ff !important;
  border: 1px solid rgba(103, 232, 249, 0.75) !important;
  background: linear-gradient(135deg, rgba(14, 116, 144, 0.45), rgba(79, 70, 229, 0.35)) !important;
}

/* 当前选中月份：与「今天」区分，更明显 */
.homePeriodPickerPopper .el-month-table td.current .cell,
.homePeriodPickerPopper .el-month-table td.current a.cell {
  background: linear-gradient(135deg, rgba(56, 189, 248, 0.9), rgba(129, 140, 248, 0.9)) !important;
  color: #0b1120 !important;
  font-weight: 700 !important;
  border: 1px solid rgba(147, 197, 253, 0.95) !important;
  box-shadow:
    0 0 14px rgba(56, 189, 248, 0.9),
    0 0 26px rgba(129, 140, 248, 0.55) !important;
}

/* Popper 箭头与暗色面板一致 */
.homePeriodPickerPopper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: rgba(56, 189, 248, 0.55) !important;
}

.homePeriodPickerPopper[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: rgba(15, 23, 42, 0.98) !important;
}

.homePeriodPickerPopper[x-placement^="top"] .popper__arrow {
  border-top-color: rgba(56, 189, 248, 0.55) !important;
}

.homePeriodPickerPopper[x-placement^="top"] .popper__arrow::after {
  border-top-color: rgba(15, 23, 42, 0.98) !important;
}
</style>
